import { Toast } from "components/ToastShow/ToastAlert";
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";




export const getDownloadUrlAttachmentAsync = (attachId ) => http({
    url: ENDPOINTS.clientPortal.clientPortal.attachment,
    method: 'get',
    params: {
        attachId: attachId
    },
    responseType:"blob"
}).then(response => {
    return response.data
}).catch((err) => {
  //   
    return Promise.reject( err);
});
function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

export const loadAttachmentViewerBase64 = (attachId , endpoint=null) => http({
   // url: ENDPOINTS.bulletinBoard.file,
   url:ENDPOINTS.clientPortal.clientPortal.attachment+"/File",
    method: 'get',
    params: {
        attachId: attachId
    },
    responseType: "blob"
}).then(async(response) => {

    return blobToBase64(response.data)
}).catch((err) => {
  //   
    return Promise.reject( err);
});

export const getAttachmentViewers = (ownerId , endpoint ) => http({
    url:   endpoint+"/List",
    method: 'get',
    params: {
        ownerId: ownerId
    }
}).then(response => response.data)
    .catch(err => {
       return Promise.reject( err);
    })